$(function() {
  if($('.product-purchase-form').length) {
    var button = $('.quantity-submit-row');
    $(window).scroll(function() {
      if ($(window).width() < 769) {
        var scroll = $(window).scrollTop();
    
        if (scroll >= $('.product-purchase-form').offset().top) { 
          button.addClass('stick');
        } else { 
          button.removeClass('stick');
        }
      }
    });
  }
});

$(document).ready(function() {
  
  /* custom mega menu */
  $(".with-products .navigation__link").on("mouseover", function () {
    $(".with-products .navigation__link").removeClass('active');
    $(this).addClass('active');
  
    var title = $(this).attr('data-menu-title');
    $(".menu_products").removeClass('active');
    $('.menu_products[data-menu="'+title+'"]').addClass('active');
  });
  /* custom mega menu */


  /* custom nutrition images */
  $('.nutrition-thumbs li button').on("click", function (e) {
    e.preventDefault();
    $(".nutrition-thumbs li button").removeClass('active');
    $(this).addClass('active');
    
    var image = $(this).attr('data-index');
    $('.nutrition-slideshow').slick('slickGoTo', image - 1);
  });
  /* custom nutrition images */

  if($('.faq-index__sticky-container').length) {
    setTimeout(function() { 
      $('#content .container .section-faq-header--with-index .faq-header .faq-index .faq-index__sticky-container .faq-index__item-container .faq-index-item:first .faq-index-item__link').addClass('active');
      $('#content .container .section-collapsible-tabs:first .cc-accordion').addClass('active');
    }, 1000);
  }

  /* bundle pages */
  if($('.custom-bundle-wrap').length) {
    var ctr = 0;
    var limit = parseInt($('.custom-bundle-wrap').attr('data-limit'));

    if($('.section-featured-product-bundle').length) {
      $('.opt-btn').on('change', function() {
        ctr = 0;
        limit = parseInt($(this).attr('data-count'));
        $('.custom-bundle-wrap').attr('data-limit', limit);

        $('.product-chosen-item').removeClass('hidden');
        $('.product-chosen-item').each(function(e){
          if(parseInt($(this).attr('data-index')) > limit) {
            $(this).addClass('hidden');
          }
        });

        $('.product-purchase-form .flavors').each(function(e){
          $(this).val("");
        });

        $('.product-chosen .product-chosen-item').each(function(e){ 
          $(this).addClass('empty-item');
          $(this).children('.not-empty').hide();
        });

        $('.quantity-wrapper input[name="quantity"]').val(1);
        $('.quantity-wrapper').hide();
        $('.btn_add_to_cart').show();

        $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', false);
        $('.btn-add-all').prop('disabled', true);
        if (limit == 1) {
          $('#add_text').text("Pick "+limit+" More Box");
        } else {
          $('#add_text').text("Pick "+limit+" More Boxes");
        }
        
        
      });
    }

    $('.btn-add-all').prop('disabled', true);
    if($('.section-featured-product-bundle').length) {
      $('.btn-add-all').html('<span id="add_text">Pick <span id="add_ctr">'+limit+'</span> More Boxes</span>');
    } else {
      $('.btn-add-all').html('<span id="add_text">Pick <span id="add_ctr">'+limit+'</span> More Bags</span>');
    }
    

    $('body').on('click', '.btn_add_to_cart', function(){
      $(this).hide();
      $(this).next().show();
      ctr = ctr + 1;

      const img = $(this).attr('data-img');
      const prod_id = $(this).attr('data-id');
      const flavor = $(this).attr('data-flavor');

      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == '') {
          $(this).val(flavor);
          return false;
        }
      });

      addToCartText(ctr,limit);
      replaceImage(img, prod_id, flavor);

    });


    $('body').on('click', '.remove-product', function(e){
      e.preventDefault();

      const prod_id = $(this).parent().attr('data-product');
      const index = $(this).parent().attr('data-index');
      const flavor = $(this).parent().attr('data-flavor');

      const elem = $('.btn_add_to_cart[data-id="'+prod_id+'"]').next().children('input');
      const qty_now = parseInt(elem.val());
      if (qty_now == 1) {
        elem.parent().hide();
        elem.parent().prev().show();
      } else {
        elem.val(qty_now-1);
      }
      ctr = ctr - 1;
      addToCartText(ctr,limit);

      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == flavor) {
          $(this).val("");
          return false;
        }
      });

      const prod_item = $(this).parent();
      prod_item.children('.not-empty').attr("src", "");
      prod_item.children('.not-empty').hide();
      prod_item.addClass('empty-item');
      prod_item.children('.empty').show();
    });

    
    $('body').on('click', '.minus', function(){
      const qty = parseInt($(this).next().val());
      const new_qty = qty - 1;
      if (new_qty < 1) {
        $(this).parent().hide();
        $(this).parent().prev().show();
        ctr = ctr - 1;
        addToCartText(ctr,limit);
      } else {
        $(this).next().val(new_qty);
        ctr = ctr - 1;
        addToCartText(ctr,limit);
      }

      const flavor = $(this).parent().prev().attr('data-flavor');
      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == flavor) {
          $(this).val("");
          return false;
        }
      });
      
      const prod_id = $(this).parent().prev().attr('data-id');
      $('.product-chosen .product-chosen-item').each(function(e){
        if($(this).attr('data-product') == prod_id && $(this).hasClass('empty-item') == false) {
          $(this).children('.not-empty').attr("src", "");
          $(this).children('.not-empty').hide();
          $(this).addClass('empty-item');
          $(this).children('.empty').show();
    
          return false;
        }
      });
    });

    
    $('body').on('click', '.plus', function(){
      const qty = parseInt($(this).prev().val());
      const new_qty = qty + 1;
      if (new_qty <= limit) {
        $(this).prev().val(new_qty);
        ctr = ctr + 1;
        addToCartText(ctr,limit);

        const img = $(this).parent().prev().attr('data-img');
        const prod_id = $(this).parent().prev().attr('data-id');
        const flavor = $(this).parent().prev().attr('data-flavor');
        replaceImage(img, prod_id, flavor);

        $('.product-purchase-form .flavors').each(function(e){
          if($(this).val() == '') {
            $(this).val(flavor);
            return false;
          }
        });
      }
    });
  }
  /* bundle pages */

  
});

// if ($('body').hasClass('template-suffix-variety-pack-product')) {
//   $(document).scroll(function () {
//       var y = $(this).scrollTop();
//     console.log('y', y);
//       if (y > 100) {
//         $('#shopify-section-announcement-bar').fadeOut();
//         $('#shopify-section-header .pageheader').fadeOut();
//       } else {
//         $('#shopify-section-announcement-bar').fadeIn();
//         $('#shopify-section-header .pageheader').fadeIn();
//       }
//   });
// }

function replaceImage(image, id, product) {
  $('.product-chosen .product-chosen-item').each(function(e){ 
    if($(this).hasClass('empty-item')) {
      $(this).attr('data-product', id);
      $(this).attr('data-flavor', product);
      $(this).children('.not-empty').show();
      $(this).children('.not-empty').attr("src", image);
      $(this).removeClass('empty-item');
      $(this).children('.empty').hide();

      return false;
    }
  });
}

function addToCartText(counter, maximum) {
  if (counter == maximum) {
    $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', true);
    $('#add_text').text("Add to Cart");
    $('.btn-add-all').removeAttr('disabled');

    $('button.plus').prop('disabled', true);
  } else {
    $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', false);
    $('.btn-add-all').prop('disabled', true);

    $('button.plus').prop('disabled', false);
    
    if(maximum-counter == 1) {
      if($('.section-featured-product-bundle').length) {
        $('#add_text').text("Pick 1 More Box");
      } else {
        $('#add_text').text("Pick 1 More Bag");
      }
    } else {
      if($('.section-featured-product-bundle').length) {
        $('#add_text').text("Pick "+(maximum-counter)+" More Boxes");
      } else {
        $('#add_text').text("Pick "+(maximum-counter)+" More Bags");
      }
    }
  }
}

/* Bundle builder (Featured product > Bundle builder block) */
(function () {
  function initBundleBuilder(root) {
    var minTotal    = parseInt(root.dataset.minTotal, 10)    || 0;
    var maxTotal    = parseInt(root.dataset.maxTotal, 10)    || 0;
    var stepTotal   = parseInt(root.dataset.stepTotal, 10)   || 1;
    var barsPerUnit = parseInt(root.dataset.barsPerUnit, 10) || 1;
    var freeEveryN  = parseInt(root.dataset.freeEveryN, 10)  || 0;
    var moneyFormat = root.dataset.moneyFormat || '$';
    if (stepTotal < 1) stepTotal = 1;
    if (barsPerUnit < 1) barsPerUnit = 1;
    if (freeEveryN < 0) freeEveryN = 0;

    function formatMoney(cents) {
      if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
        try { return theme.Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
      }
      return '$' + (Math.round(cents) / 100).toFixed(2);
    }

    var progressEl = root.querySelector('[data-bundle-progress]');
    var ctaEl      = root.querySelector('[data-bundle-cta]');
    var errorEl    = root.querySelector('[data-bundle-error]');
    var rows       = root.querySelectorAll('[data-bundle-row]');

    // Optional visual tier bar (percentage discounts). Purely presentational —
    // actual discounts are applied by Shopify automatic discounts. Lights up
    // one step per bag added; the last step stays active for "3+".
    var tierEl    = root.querySelector('[data-bundle-tier]');
    var tierSteps = tierEl ? tierEl.querySelectorAll('.step') : [];
    var tierFill  = tierEl ? tierEl.querySelector('.bundle-progress-bar-active') : null;
    // Percentage discount attached to each tier step (e.g. 0, 10, 15). The last
    // step's percentage applies to any total at or beyond that step ("3+").
    var tierPcts  = Array.prototype.map.call(tierSteps, function (s) {
      return parseFloat(s.getAttribute('data-pct')) || 0;
    });

    // Discount (in cents) implied by the active tier for a given bag count.
    // Presentational — mirrors the Shopify automatic discount so the CTA shows
    // the price the customer will actually pay at checkout.
    function tierDiscountCents(total, totalCents) {
      if (!tierPcts.length || total <= 0) return 0;
      var pct = tierPcts[Math.min(total, tierPcts.length) - 1] || 0;
      return Math.round(totalCents * pct / 100);
    }

    // Struck-through full price, shown only when a discount actually applies.
    function strikeSpan(str) {
      return '<span style="text-decoration:line-through;text-decoration-thickness:2px;opacity:0.7;font-weight:500;margin-right:6px;">' + str + '</span>';
    }

    function updateTier(total) {
      if (!tierEl || !tierSteps.length) return;
      var stepCount = tierSteps.length;
      var activeCount = Math.min(total, stepCount);
      tierSteps.forEach(function (step, i) {
        var lbl = step.querySelector('.step-label');
        if (lbl) lbl.classList.toggle('active', i < activeCount);
      });
      var denom = stepCount > 1 ? stepCount - 1 : 1;
      var reached = Math.max(0, activeCount - 1);
      if (tierFill) tierFill.style.width = ((reached / denom) * 68) + '%';
    }

    var tplIncomplete   = root.dataset.progressIncomplete   || '';
    var tplFreeUnlocked = root.dataset.progressFreeUnlocked || '';
    var tplReady        = root.dataset.progressReady        || '';
    var ctaLabel        = root.dataset.ctaReady             || '';

    function fill(tpl, vars) {
      return (tpl || '').replace(/\[(added_bars|target_bars|remaining_bars_total|remaining_bars|free_bars_at_target|min_bars|max_bars|bars_per_unit|total_full_strike|total_full|total_cents|total|min_total|max_total|discount|free_count|paid_count|added|target|remaining|step)\]/g, function (_, key) {
        return vars[key] != null ? vars[key] : '';
      });
    }

    function getTotal() {
      var total = 0;
      rows.forEach(function (row) {
        var q = parseInt(row.dataset.qty || '0', 10) || 0;
        total += q;
      });
      return total;
    }

    function getTotalCents() {
      var cents = 0;
      rows.forEach(function (row) {
        var q = parseInt(row.dataset.qty || '0', 10) || 0;
        var p = parseInt(row.dataset.price || '0', 10) || 0;
        cents += q * p;
      });
      return cents;
    }

    /**
     * Buy N-1, get 1 free: every Nth item in the cart is free, choosing
     * the cheapest items as the free ones.
     * Returns { freeCount, paidCount, discountCents }.
     */
    function getDiscount(total) {
      if (freeEveryN <= 0 || total <= 0) {
        return { freeCount: 0, paidCount: total, discountCents: 0 };
      }
      var freeCount = Math.floor(total / freeEveryN);
      if (freeCount <= 0) {
        return { freeCount: 0, paidCount: total, discountCents: 0 };
      }
      var prices = [];
      rows.forEach(function (row) {
        var q = parseInt(row.dataset.qty || '0', 10) || 0;
        var p = parseInt(row.dataset.price || '0', 10) || 0;
        for (var i = 0; i < q; i++) prices.push(p);
      });
      prices.sort(function (a, b) { return a - b; });
      var discountCents = 0;
      for (var j = 0; j < freeCount && j < prices.length; j++) {
        discountCents += prices[j];
      }
      return {
        freeCount: freeCount,
        paidCount: total - freeCount,
        discountCents: discountCents
      };
    }

    function nextTarget(total) {
      if (total < minTotal) return minTotal;
      if (maxTotal > 0 && total >= maxTotal) return maxTotal;
      var next = Math.ceil((total + 1) / stepTotal) * stepTotal;
      if (next < minTotal) next = minTotal;
      if (maxTotal > 0 && next > maxTotal) next = maxTotal;
      return next;
    }

    function isValidTotal(total) {
      if (total < minTotal) return false;
      if (maxTotal > 0 && total > maxTotal) return false;
      return (total % stepTotal === 0);
    }

    /**
     * Build a vars object simulating "min_total items at the unit price".
     * Used for the CTA label while the bundle is below the minimum,
     * so the customer sees the deal they'd get by completing the bundle.
     */
    function buildPreviewVars() {
      var unitPrice = 0;
      for (var i = 0; i < rows.length; i++) {
        var p = parseInt(rows[i].dataset.price || '0', 10) || 0;
        if (p > 0) { unitPrice = p; break; }
      }
      var simTotal       = minTotal;
      var simTotalCents  = unitPrice * simTotal;
      var simFreeCount   = freeEveryN > 0 ? Math.floor(simTotal / freeEveryN) : 0;
      var simTierDisc    = tierDiscountCents(simTotal, simTotalCents);
      var simDiscountCt  = simFreeCount * unitPrice + simTierDisc;
      var simPayCents    = Math.max(0, simTotalCents - simDiscountCt);
      var simTotalFull   = formatMoney(simTotalCents);
      return {
        added: simTotal,
        target: simTotal,
        remaining: 0,
        step: stepTotal,
        min_total: minTotal,
        max_total: maxTotal,
        added_bars: simTotal * barsPerUnit,
        target_bars: simTotal * barsPerUnit,
        remaining_bars: 0,
        remaining_bars_total: 0,
        free_bars_at_target: simFreeCount * barsPerUnit,
        min_bars: minTotal * barsPerUnit,
        max_bars: maxTotal * barsPerUnit,
        bars_per_unit: barsPerUnit,
        total: formatMoney(simPayCents),
        total_full: simTotalFull,
        total_full_strike: simPayCents < simTotalCents ? strikeSpan(simTotalFull) : '',
        discount: formatMoney(simDiscountCt),
        total_cents: simPayCents,
        free_count: simFreeCount,
        paid_count: simTotal - simFreeCount
      };
    }

    function update() {
      var total = getTotal();
      var target = nextTarget(total);
      var remaining = Math.max(0, target - total);
      var ready = isValidTotal(total) && total > 0;

      var totalCents = getTotalCents();
      var disc = getDiscount(total);
      var tierDisc = tierDiscountCents(total, totalCents);
      var payCents = Math.max(0, totalCents - disc.discountCents - tierDisc);
      var totalFullStr = formatMoney(totalCents);

      // Paid-only counts (what user actually needs to add — free portion stripped out)
      var freeAtTarget = freeEveryN > 0 ? Math.floor(target / freeEveryN) : 0;
      var paidAtTarget = target - freeAtTarget;
      var paidAtTotal  = total  - disc.freeCount;
      var remainingPaid = Math.max(0, paidAtTarget - paidAtTotal);

      var vars = {
        added: total,
        target: target,
        remaining: remaining,
        step: stepTotal,
        min_total: minTotal,
        max_total: maxTotal,
        added_bars: total * barsPerUnit,
        target_bars: target * barsPerUnit,
        // Bars the customer still has to PAY for to reach the next target
        // (excludes the bars that will be free at that target).
        remaining_bars: remainingPaid * barsPerUnit,
        // Bars-as-pack-count without subtracting free portion (rarely needed)
        remaining_bars_total: remaining * barsPerUnit,
        // How many bars they get for free at the next target
        free_bars_at_target: freeAtTarget * barsPerUnit,
        min_bars: minTotal * barsPerUnit,
        max_bars: maxTotal * barsPerUnit,
        bars_per_unit: barsPerUnit,
        total: formatMoney(payCents),
        total_full: totalFullStr,
        total_full_strike: payCents < totalCents ? strikeSpan(totalFullStr) : '',
        discount: formatMoney(disc.discountCents + tierDisc),
        total_cents: payCents,
        free_count: disc.freeCount,
        paid_count: disc.paidCount
      };

      // Three progress states:
      //   ready          → bundle is at a valid step (e.g. 24, 48 bars) — show tplReady
      //   free-unlocked  → paid quota met but bundle below min_total and a free pack is still
      //                    sitting unclaimed (e.g. 16 of 24) — show tplFreeUnlocked if configured
      //   incomplete     → still need to add paid bars — show tplIncomplete
      var freeUnlocked = !ready && total > 0 && remainingPaid === 0 && freeAtTarget > 0 && tplFreeUnlocked;
      var tpl = ready ? tplReady : (freeUnlocked ? tplFreeUnlocked : tplIncomplete);
      progressEl.innerHTML = fill(tpl, vars);
      progressEl.classList.toggle('is-ready', ready);
      progressEl.classList.toggle('is-free-unlocked', !!freeUnlocked);

      updateTier(total);

      // CTA label always reflects the deal at min_total (a "preview"),
      // so the disabled button still shows the price the customer will get.
      var ctaVars = ready ? vars : buildPreviewVars();
      ctaEl.innerHTML = fill(ctaLabel, ctaVars);
      ctaEl.disabled = !ready;
      ctaEl.classList.toggle('is-ready', ready);

      if (maxTotal > 0 && total >= maxTotal) {
        rows.forEach(function (row) {
          var plus = row.querySelector('[data-bundle-plus]');
          if (plus) plus.disabled = true;
        });
      } else {
        rows.forEach(function (row) {
          var plus = row.querySelector('[data-bundle-plus]');
          if (plus) plus.disabled = false;
        });
      }
    }

    function setQty(row, qty) {
      if (qty < 0) qty = 0;
      row.dataset.qty = qty;
      var qtyEl  = row.querySelector('[data-bundle-qty]');
      var addEl  = row.querySelector('[data-bundle-add]');
      var stepEl = row.querySelector('[data-bundle-stepper]');
      if (qtyEl) qtyEl.textContent = qty;
      if (qty > 0) {
        if (addEl)  addEl.style.display  = 'none';
        if (stepEl) stepEl.style.display = '';
      } else {
        if (addEl)  addEl.style.display  = '';
        if (stepEl) stepEl.style.display = 'none';
      }
      update();
    }

    rows.forEach(function (row) {
      row.dataset.qty = '0';
      if (row.dataset.soldOut === '1') return;
      var add   = row.querySelector('[data-bundle-add]');
      var plus  = row.querySelector('[data-bundle-plus]');
      var minus = row.querySelector('[data-bundle-minus]');

      if (add)   add.addEventListener('click', function () { setQty(row, 1); });
      if (plus)  plus.addEventListener('click', function () {
        var total = getTotal();
        if (maxTotal > 0 && total >= maxTotal) return;
        setQty(row, (parseInt(row.dataset.qty, 10) || 0) + 1);
      });
      if (minus) minus.addEventListener('click', function () {
        setQty(row, (parseInt(row.dataset.qty, 10) || 0) - 1);
      });
    });

    ctaEl.addEventListener('click', function (evt) {
      if (evt && evt.preventDefault) evt.preventDefault();
      if (ctaEl.disabled) return;
      errorEl.style.display = 'none';
      ctaEl.classList.add('is-loading');
      ctaEl.disabled = true;

      var items = [];
      rows.forEach(function (row) {
        var qty = parseInt(row.dataset.qty, 10) || 0;
        if (qty > 0) {
          items.push({ id: parseInt(row.dataset.variantId, 10), quantity: qty });
        }
      });

      var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (r) {
        if (!r.ok) throw new Error((r.body && r.body.description) || 'Unable to add to cart');

        // Open Rebuy Smart Cart if it's on the page; it auto-refreshes its own contents.
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          try { window.Rebuy.SmartCart.show(); } catch (e) {}
        } else {
          // Fallback: native theme drawer (only when Rebuy isn't loaded).
          document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false }));
        }

        rows.forEach(function (row) { setQty(row, 0); });
      })
      .catch(function (err) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
        errorEl.style.display = '';
      })
      .finally(function () {
        ctaEl.classList.remove('is-loading');
        update();
      });
    });

    update();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

